import styled from "styled-components";
import { formatTransactionParams } from "../utils/transactionFormatter";
import { hashEllipsis } from "../utils/viewFuncs/text";
import { formatBalance } from "../utils/format";

const ParamsWrapper = styled.div`
  font-size: 13px;
  line-height: 1.5;
  color: #4b5563;
`;

const ParamRow = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .label {
    color: #6b7280;
  }

  .value {
    color: #111827;
    font-weight: 500;
  }

  .address {
    font-family: monospace;
    font-size: 12px;
  }
`;

const AmountRow = styled.div`
  color: #111827;
  font-weight: 600;
  font-size: 14px;
`;

export default function SimpleParametersDisplay({ extrinsic }) {
  if (!extrinsic || !extrinsic.call) {
    return null;
  }

  const params = formatTransactionParams(extrinsic);

  // For transfers, show a nice compact display
  if (params.type === "transfer" && params.to && params.amount) {
    return (
      <ParamsWrapper>
        <ParamRow>
          <span className="label">To:</span>
          <span className="value address">{hashEllipsis(params.to, 6, 4)}</span>
        </ParamRow>
        {/* <AmountRow>{formatBalance(params.amount, 12)}</AmountRow> */}
      </ParamsWrapper>
    );
  }

  // For contract calls
  if (params.type === "contract_call" && params.to) {
    return (
      <ParamsWrapper>
        <ParamRow>
          <span className="label">Contract:</span>
          <span className="value address">{hashEllipsis(params.to, 6, 4)}</span>
        </ParamRow>
        {/* Value display removed */}
        {/* {params.value && params.value !== "0" && (
          <ParamRow>
            <span className="label">Value:</span>
            <span className="value">
              {formatBalance(params.value, 12)}
            </span>
          </ParamRow>
        )} */}
      </ParamsWrapper>
    );
  }

  // For timestamp.set, show it's a system call
  if (
    extrinsic.call.section === "timestamp" &&
    extrinsic.call.method === "set"
  ) {
    return (
      <ParamsWrapper>
        <ParamRow>
          <span className="label" style={{ fontStyle: "italic" }}>
            System operation
          </span>
        </ParamRow>
      </ParamsWrapper>
    );
  }

  // Default: show first argument if available
  const args = extrinsic.call.args || [];
  if (args.length > 0 && args[0]) {
    const firstArg = args[0];
    let displayValue = "";

    if (typeof firstArg === "object" && firstArg.id) {
      displayValue = hashEllipsis(firstArg.id, 6, 4);
    } else if (typeof firstArg === "string") {
      displayValue =
        firstArg.length > 20 ? hashEllipsis(firstArg, 8, 6) : firstArg;
    } else {
      displayValue = JSON.stringify(firstArg);
    }

    return (
      <ParamsWrapper>
        <ParamRow>
          <span className="value">{displayValue}</span>
        </ParamRow>
      </ParamsWrapper>
    );
  }

  return null;
}
